import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { arrayConversion, checkJSON } from '../../utils/verifier.utils';


class VenuesTab extends Component {
    constructor(props) {
        super(props);

        this.convertArray = this.convertArray.bind(this);
        this.renderCheckboxGroup = this.renderCheckboxGroup.bind(this);
    }

    convertArray = (dataSet, idKey) => {
        const { currentConfiguration } = this.props;
        return currentConfiguration !== '' ? arrayConversion(currentConfiguration[dataSet], idKey) : [];
    };

    renderCheckboxGroup = (title, items, arrayItems, idKey, allCheckboxName) => {
        const { hasPermission, handleAllInputChange, handleInputChange, searchValue } = this.props;

        const filteredItems = items.filter(item =>
            item.name.toLowerCase().includes(searchValue.toLowerCase())
        );

        const allFilteredSelected = filteredItems.length > 0 && filteredItems.every(item =>
            arrayItems.includes(item[idKey])
        );

        return (
            <div className="col-md-4" key={idKey}>
                <div
                    className={`custom-checkbox ${!hasPermission && arrayItems.length === 0 ? 'hidden' : ''}`}
                    style={{ borderBottom: '2px solid #ccc', paddingBottom: '5px', display: 'inline-block', width: '100%' }}
                    key={`${allCheckboxName}_tittle`}
                >
                    <input
                        name={allCheckboxName}
                        disabled={!hasPermission}
                        checked={allFilteredSelected}
                        onChange={e => handleAllInputChange(e, items, idKey)}
                        type="checkbox"
                        id={`${allCheckboxName}_tittle`}
                    />
                    <label className="checkbox-inline title" htmlFor={`${allCheckboxName}_tittle`} id={`${allCheckboxName}_tittle`}>
                        <h3 style={{fontWeight: 800}}>
                            <span> </span>
                            {title}
                        </h3>
                    </label>
                </div>
                {filteredItems.map((item, index) => (
                    <div
                        className={`custom-checkbox ${!hasPermission && arrayItems.indexOf(item[idKey]) === -1 ? 'hidden' : ''}`}
                        key={`${allCheckboxName}_${index}`}
                    >
                        <input
                            name={allCheckboxName}
                            disabled={!hasPermission}
                            checked={arrayItems.indexOf(item[idKey]) > -1}
                            onChange={e => handleInputChange(e, item[idKey], idKey)}
                            type="checkbox"
                            id={`${allCheckboxName}_${index}`}
                        />
                        <label className="checkbox-inline" htmlFor={`${allCheckboxName}_${index}`}>
                            <span> </span>
                            {checkJSON(item.name) || item.name}
                        </label>
                    </div>
                ))}
            </div>
        );
    };

    render() {
        const { venues, extras, access, intl } = this.props;

        const groups = [
            {
                title: intl.formatMessage({ id: 'title.venues', defaultMessage: 'Venues' }),
                items: venues,
                arrayItems: this.convertArray('verifierVenueCapacitySet', 'venueCapacityId'),
                idKey: 'venueCapacityId',
                allCheckboxName: 'verifierVenueCapacitySet'
            },
            {
                title: intl.formatMessage({ id: 'title.extras', defaultMessage: 'Extras' }),
                items: extras,
                arrayItems: this.convertArray('verifierExtraSet', 'extraId'),
                idKey: 'extraId',
                allCheckboxName: 'verifierExtraSet'
            },
            {
                title: intl.formatMessage({ id: 'title.access', defaultMessage: 'Accesos' }),
                items: access,
                arrayItems: this.convertArray('verifierAccessSet', 'accessId'),
                idKey: 'accessId',
                allCheckboxName: 'verifierAccessSet'
            }
        ];

        return (
            <div className="row">
                {groups.map(group => this.renderCheckboxGroup(
                    group.title,
                    group.items,
                    group.arrayItems,
                    group.idKey,
                    group.allCheckboxName
                ))}
            </div>
        );
    }
}

export default injectIntl(VenuesTab);
